export function getTimeDomainData(analyserNode) {
  if (!analyserNode) return null;
  const timeDomainData = new Uint8Array(analyserNode.fftSize);
  analyserNode.getByteTimeDomainData(timeDomainData);
  return timeDomainData;
}

export function getSmoothedAmplitude(sigma = 5, kernelSize = 15, analyserNode) {
  const timeDomainData = getTimeDomainData(analyserNode);
  if (!timeDomainData) return null;

  let normalizedData = new Float32Array(timeDomainData.length);
  for (let i = 0; i < timeDomainData.length; i++) {
    normalizedData[i] = (timeDomainData[i] - 128) / 128;
  }

  let kernel = new Float32Array(kernelSize);
  let sum = 0;
  const center = Math.floor(kernelSize / 2);
  for (let i = 0; i < kernelSize; i++) {
    let x = i - center;
    kernel[i] = Math.exp(-(x * x) / (2 * sigma * sigma));
    sum += kernel[i];
  }
  for (let i = 0; i < kernelSize; i++) {
    kernel[i] /= sum;
  }

  let smoothedData = new Float32Array(normalizedData.length);
  for (let i = 0; i < normalizedData.length; i++) {
    let weightedSum = 0;
    let weightTotal = 0;
    for (let j = 0; j < kernelSize; j++) {
      let index = i + j - center;
      if (index >= 0 && index < normalizedData.length) {
        weightedSum += normalizedData[index] * kernel[j];
        weightTotal += kernel[j];
      }
    }
    smoothedData[i] = weightedSum / weightTotal;
  }

  let sumSquares = 0;
  for (let i = 0; i < smoothedData.length; i++) {
    sumSquares += smoothedData[i] * smoothedData[i];
  }
  return Math.sqrt(sumSquares / smoothedData.length);
}

export function decodeAudioChunk(chunk) {
  try {
    const audioData = atob(chunk);
    const buffer = new ArrayBuffer(audioData.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < audioData.length; i++) {
      view[i] = audioData.charCodeAt(i);
    }
    return buffer;
  } catch (error) {
    console.error("Error decoding audio chunk:", error);
    return null;
  }
}

export function getRemainingDuration() {
  if (window.pcmPlayer?.activeBufferSources?.size > 0) {
    return window.pcmPlayer.startTime - window.pcmPlayer.audioCtx.currentTime;
  }
  return 0;
}

/**
 * Restores keyboard focus to the page after Safari steals it during permission
 * dialogs or mic state changes. Safari does not reliably accept document.body.focus(),
 * so we create a temporary off-screen input, focus it, then remove it — this hands
 * focus back to the page so window.keydown events resume firing.
 */
export function restorePageFocus() {
  const tmp = document.createElement("input");
  tmp.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;pointer-events:none;";
  document.body.appendChild(tmp);
  tmp.focus();
  requestAnimationFrame(() => document.body.removeChild(tmp));
}
